import { getStageOrgPool } from "../../content/index.js";
import { createLcg } from "../rng/lcg.js";
import { shuffle } from "../rng/shuffle.js";
import type { OrganizationId } from "../types/index.js";

export type PickOrganizationsInput = {
  owned: readonly OrganizationId[];
  rngState: number;
  stageId?: string;
};

export type PickOrganizationsResult = {
  organizationIds: OrganizationId[];
  rngState: number;
};

export function pickOrganizations(input: PickOrganizationsInput): PickOrganizationsResult {
  const pool = getStageOrgPool(input.stageId);
  const unowned = pool.filter((id) => !input.owned.includes(id));
  const rng = createLcg(input.rngState);
  const shuffled = shuffle(unowned, rng);
  return {
    organizationIds: shuffled.slice(0, Math.min(2, shuffled.length)),
    rngState: rng.state,
  };
}
